import { Link } from 'react-router-dom';

const virtualizationServices = [
  {
    title: 'Support Services',
    description: '24/7 operational support, troubleshooting, and lifecycle management of your virtual environments.'
  },
  {
    title: 'Managed Services',
    description: 'Full-stack management including capacity planning, patching, performance optimization, and reporting.'
  },
  {
    title: 'Storage Virtualization',
    description: 'Consolidate storage resources into unified pools for simplified provisioning and higher availability.'
  },
  {
    title: 'Network Virtualization',
    description: 'Policy-driven segmentation, virtual network overlays, and software-defined networking architectures.'
  },
  {
    title: 'Software Defined Data Center',
    description: 'Unify compute, storage, and network virtualization with automated orchestration and governance.'
  },
  {
    title: 'DevOps Enablement',
    description: 'Integrate virtualization into CI/CD pipelines with templated environments and infrastructure as code.'
  }
];

const Virtualization = () => {
  return (
    <>
      <section className="page-intro">
        <div className="container">
          <h1>Virtualization Solutions</h1>
          <p>
            Nexus IT leverages virtualization to unlock flexible, scalable, and efficient IT environments by abstracting
            hardware resources into logical services across compute, network, and desktops.
          </p>
        </div>
      </section>

      <section className="content-section">
        <div className="container">
          <div className="section-header">
            <span className="tagline">Foundation</span>
            <h2 className="section-title">Why Virtualization Matters</h2>
            <p className="section-lead">
              Virtualization introduces an abstraction layer between hardware and software, enabling multiple operating
              systems and applications to share the same physical infrastructure for improved utilization and agility.
            </p>
          </div>

          <div className="service-grid">
            <article className="service-card">
              <h3>Server Virtualization</h3>
              <p>Run multiple operating systems on a single physical server to increase utilization and simplify management.</p>
            </article>
            <article className="service-card">
              <h3>Network Virtualization</h3>
              <p>Create logical network services—switching, routing, firewalls, load balancers—decoupled from hardware to accelerate provisioning.</p>
            </article>
            <article className="service-card">
              <h3>Desktop Virtualization</h3>
              <p>Deliver desktops and applications securely to branch offices, remote teams, and mobile users across any device.</p>
            </article>
          </div>
        </div>
      </section>

      <section className="section alt">
        <div className="container">
          <div className="section-header">
            <span className="tagline">How We Help</span>
            <h2 className="section-title">Comprehensive Virtualization Services</h2>
          </div>
          <div className="service-grid">
            {virtualizationServices.map((service) => (
              <article className="service-card" key={service.title}>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="cta-banner">
            <div>
              <h2>Accelerate with Virtualization</h2>
              <p>
                Adopt a flexible platform that supports modernization initiatives, hybrid cloud migration, and digital
                workplaces.
              </p>
            </div>
            <Link className="btn btn-primary" to="/contact">
              Talk to Our Architects
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default Virtualization;
